import { SecureStorage } from '@/services/shared/storage/SecureStorage';
import { clearAllCookies } from '@/services/shared/cookies';
import { resetAuth } from '@/store/slices/authSlice';

export async function logoutAndClear(dispatch?: (action: any) => any): Promise<void> {
  try {
    await SecureStorage.getInstance().clearTokens();
  } catch (e) {
    // no-op
  }

  try {
    await clearAllCookies();
  } catch (e) {
    // no-op
  }

  try {
    if (dispatch) {
      dispatch(resetAuth());
    }
  } catch (e) {
    // no-op
  }
}


